import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ResultOptions } from 'src/app/shared/utils/resultOptions';

@Component({
  selector: 'app-modal-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
})
export class ResultComponent implements OnInit {
  public resultActionFormControl: FormControl;

  @Output() private emitCloseService = new EventEmitter<boolean>();
  @Output() private emitDismissService = new EventEmitter<boolean>();
  @Output() private emitSendService = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {
    this.createResultActionFormControl();
  }

  private createResultActionFormControl(): void {
    this.resultActionFormControl = new FormControl(
      ResultOptions.GENERATE_REPORT
    );
  }

  public onClose(): void {
    this.emitCloseService.emit(true);
  }

  public onDismiss(): void {
    this.emitDismissService.emit();
  }

  public onSend(): void {
    this.emitSendService.emit(this.resultActionFormControl.value);
    this.emitCloseService.emit(true);
  }
}
